import { fetchCurrentUser } from '../../ducks/user.duck';
import { retrieveOmiseRecipient } from '../StripePayoutPage/StripePayoutPage.duck';

export const loadData = () => async (dispatch, getState) => {
  const response = await dispatch(
    fetchCurrentUser({
      updateHasListings: false,
      updateNotifications: false,
    })
  );

  const recipientId =
    getState()?.user?.currentUser?.attributes?.profile?.publicData?.omiseRecipientId;

  if (recipientId) {
    await dispatch(retrieveOmiseRecipient());
  }

  return response;
};
